import {DataStatus, Pagination} from 'platform/components';

import {useRef, useState} from 'react';

import {useOnMount} from 'shared/web';

import {useHttpCalls} from '../hooks/useHttpCalls';
import {RowV5ResponseBody} from '../types/Api';

interface ControlledRowControlProps {
  gridCode: string;
  dataQueryId: string;
  onPageChange: (row: RowV5ResponseBody) => Promise<boolean>;
  entityId: string;
  isDisabled?: boolean;
}

export function ControlledRowControl(props: ControlledRowControlProps) {
  const http = useHttpCalls({gridCode: props.gridCode});
  const rows = useRef<RowV5ResponseBody[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [rowIndex, setRowIndex] = useState(1);

  useOnMount(() => {
    http.getDataByQuery(props.dataQueryId, 0, 1000, false, []).then((response) => {
      rows.current = response ?? [];
      const newRowIndex = response?.find((id) => id.id === props.entityId)?.rowNumber;
      setRowIndex(newRowIndex as number);
      setIsLoading(false);
    });
  });

  const handlePageChange = async (newPage: number) => {
    const newRow = rows.current.find((row) => row.rowNumber === newPage);

    if (!newRow) {
      return;
    }

    const success = await props.onPageChange(newRow);

    if (!success) {
      return;
    }

    setRowIndex(newPage);
  };

  if (isLoading) {
    return <DataStatus isLoading></DataStatus>;
  }

  return (
    <Pagination
      isDisabled={props.isDisabled}
      variant="text-only"
      showPrevButton
      showNextButton
      // eslint-disable-next-line react-hooks/refs
      pagesQuantity={rows.current.length}
      onPageChange={handlePageChange}
      page={rowIndex}
    />
  );
}
